import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { SelectField, withNamespace } from "components/Form/FormikControls";

import {
  getBreeds,
  getCategories,
  getSpeciesAttributeOptions,
} from "selectors";
import { getOptions } from "selectors/speciesAttributes";
import {
  attributeOrderSort,
  attributeSpeciesFilter,
} from "lib/speciesAttributes";

interface AnimalHealthFieldProps {
  label?: string;
  name?: string;
  ns?: string;
  isClearable?: boolean;
  disabled?: boolean;
  menuPortalTarget?: HTMLElement;
  selectedBreedId?: number | null;
}
export function AnimalHealthField(
  props: AnimalHealthFieldProps,
): React.JSX.Element {
  const {
    ns,
    name = "category_id",
    label = "Animal Health",
    isClearable = false,
    disabled = false,
    menuPortalTarget = undefined,
    selectedBreedId = null,
  } = props;

  const speciesAttributeOptions = useSelector(getSpeciesAttributeOptions);
  const breeds = useSelector(getBreeds);
  const allCategories = useSelector(getCategories);

  const { categories: speciesOptionsCategories } = speciesAttributeOptions;

  const categories = useMemo(() => {
    if (selectedBreedId != null) {
      const speciesId = breeds[selectedBreedId]?.species_id || null;
      return getOptions(
        Object.values(allCategories)
          .filter(attributeSpeciesFilter(speciesId))
          .sort(attributeOrderSort),
      );
    }
    return speciesOptionsCategories;
  }, [selectedBreedId, breeds, allCategories, speciesOptionsCategories]);

  return (
    <SelectField
      label={label}
      name={withNamespace(ns, name)}
      options={categories}
      isClearable={isClearable}
      disabled={disabled}
      menuPortalTarget={menuPortalTarget || document.body}
    />
  );
}
